import { useQuery } from '@tanstack/react-query';

import { PluginEquifaxPpsrGrantorSearchFormResponse } from '../../../../types/plugins';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { runEquifaxPpsrGrantorSearchForm } from '../../requests/runEquifaxPpsrGrantorSearchForm';

export const useEquifaxPpsrGrantorSearchForm = (
  applicationUuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructPost } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<PluginEquifaxPpsrGrantorSearchFormResponse> | undefined
  >({
    queryKey: [
      PLUGIN_BASE_PATH,
      'equifax-ppsr-grantor-search-form',
      applicationUuid,
    ],
    queryFn: () =>
      runEquifaxPpsrGrantorSearchForm(constructPost, {
        params: { uuid: applicationUuid },
      }),
    enabled: !!applicationUuid,
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'formData'), ...rest };
};
